import ninegrid from "../index.js";

export class ngCustomEvent
{
	#owner;
	
	/**
	 * focus event, keyboard event, mouse event : common.js
	 * 
	 * ninegrid.EVENT.LAYOUT_CHANGED : ngFoot.js
	 * ninegrid.EVENT.ROW_POS_CHANGED, ninegrid.EVENT.CELL_POS_CHANGED : ngCellManager.js
	 */
	
	constructor(owner) {
		this.#owner = owner;
		//console.log(this.#owner);
		//const ngFoot	= this.#owner.shadowRoot.querySelector("ng-foot");
		//const nglayout	= ngFoot.shadowRoot.querySelector("ng-layout");
		
		this.#resetEvent();
		
		this.#owner.addEventListener(ninegrid.EVENT.LAYOUT_CHANGED, e => {
			this.#resetEvent();
		});
	}
	
	#resetEvent = () => {
		
		//this.#owner.shadowRoot.querySelector(".ng-table tbody").addEventListener("click", this.#onCellClicked);
		$(".ng-table tbody",			this.#owner.shadowRoot).on("click",		"th,td",	this.#onCellClick);
		$(".ng-table thead",			this.#owner.shadowRoot).on("click",		"th,td",	this.#onHeadClick);
		$(".ng-table tfoot",			this.#owner.shadowRoot).on("click",		"th,td",	this.#onFootClick);
	};
	
	#onCellClick = e => {
		
		//console.log(e, e.detail);
		
		if (![1,2].includes(e.detail)) return;
		
		const properties	= ["altKey","ctrlKey","shiftKey","clientX","clientY","offsetX","offsetY","pageX","pageY","screenX","screenY","button","buttons","whitch"];
 		const cell			= e.target.closest("th,td");
		const eventType		= e.detail == 1 ? ninegrid.EVENT.CELL_CLICK : ninegrid.EVENT.CELL_DBL_CLICK;
 		
 		const customEvent	= new CustomEvent(eventType, { bubbles: true, composed: true, detail: { target: cell } });
 		customEvent.col		= cell.dataset.col;
 		customEvent.row		= cell.dataset.row;
		customEvent.subrow	= parseInt(cell.dataset.matrixRow) % parseInt(cell.dataset.row);
		customEvent.bind	= cell.dataset.bind;
		
		ninegrid.copyProperty(customEvent, e, properties);
 		
 		this.#owner.dispatchEvent(customEvent);
 	};
	
	#onHeadClick = e => {
			
		if (![1,2].includes(e.detail)) return;
		
		const properties	= ["altKey","ctrlKey","shiftKey","clientX","clientY","offsetX","offsetY","pageX","pageY","screenX","screenY","button","buttons","whitch"];
 		const cell			= e.target.closest("th,td");
		const eventType		= e.detail == 1 ? ninegrid.EVENT.HEADCELL_CLICK : ninegrid.EVENT.HEADCELL_DBL_CLICK;
 		
 		const customEvent	= new CustomEvent(eventType, { bubbles: true, composed: true, detail: { target: cell } });
 		customEvent.col		= cell.dataset.col;
		
		ninegrid.copyProperty(customEvent, e, properties);
 		
 		this.#owner.dispatchEvent(customEvent);
 	};
	
	#onFootClick = e => {
				
		if (![1,2].includes(e.detail)) return;
		
		const properties	= ["altKey","ctrlKey","shiftKey","clientX","clientY","offsetX","offsetY","pageX","pageY","screenX","screenY","button","buttons","whitch"];
 		const cell			= e.target.closest("th,td");
		const eventType		= e.detail == 1 ? ninegrid.EVENT.FOOTCELL_CLICK : ninegrid.EVENT.FOOTCELL_DBL_CLICK;
 		
 		const customEvent	= new CustomEvent(eventType, { bubbles: true, composed: true, detail: { target: cell } });
 		customEvent.col		= cell.dataset.col;
		
		ninegrid.copyProperty(customEvent, e, properties);
 		
 		this.#owner.dispatchEvent(customEvent);
 	};

}


